import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../lib/api';

export const TournamentStats = ({ tournamentId }) => {
  const [stats, setStats] = useState(null);
  
  useEffect(() => {
    const loadStats = async () => {
      try {
        const res = await axios.get(`${API}/tournaments/${tournamentId}/stats`);
        setStats(res.data);
      } catch (e) {
        console.error(e);
      }
    };
    loadStats();
  }, [tournamentId]);

  if (!stats) return null;

  const stats_items = [
    { label: 'ÉQUIPES', value: stats.total_teams, color: '#ff4500' },
    { label: 'MATCHS', value: stats.total_matches, color: '#00ff9d' },
    { label: 'COMPLÉTÉS', value: stats.completed_matches, color: '#4169e1' },
    { label: 'ROUNDS', value: stats.total_rounds_played, color: '#ffd700' }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {stats_items.map((item, idx) => (
        <div key={idx} className="bg-[#0a0a0a] border border-[#262626] p-4 corner-decoration relative hover-lift" data-testid={`stat-${item.label}`}>
          <p className="font-secondary text-xs text-muted-foreground uppercase tracking-wider mb-2">{item.label}</p>
          <p className="font-secondary text-3xl font-black" style={{ color: item.color }}>{item.value}</p>
        </div>
      ))}
    </div>
  );
};

export const TeamStatsCard = ({ team }) => {
  if (!team.stats || team.stats.total_matches === 0) {
    return (
      <div className="text-center py-8">
        <p className="font-secondary text-xs text-muted-foreground">Aucune statistique disponible</p>
      </div>
    );
  }

  const { stats } = team;
  const winRateWidth = stats.win_rate || 0;

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <span className="font-secondary text-xs uppercase text-muted-foreground">Taux de victoire</span>
        <span className="font-secondary text-lg font-bold text-[#ff4500]">{stats.win_rate}%</span>
      </div>
      <div className="stat-bar">
        <div className="stat-bar-fill" style={{ width: `${winRateWidth}%` }} />
      </div>
      
      <div className="grid grid-cols-2 gap-4 mt-4">
        <div>
          <p className="font-secondary text-xs text-muted-foreground uppercase">Matchs</p>
          <p className="font-secondary text-xl font-bold text-[#00ff9d]">{stats.matches_won}W - {stats.matches_lost}L</p>
        </div>
        <div>
          <p className="font-secondary text-xs text-muted-foreground uppercase">Rounds</p>
          <p className="font-secondary text-xl font-bold text-[#4169e1]">{stats.rounds_won}W - {stats.rounds_lost}L</p>
        </div>
      </div>
    </div>
  );
};

export const Leaderboard = ({ isPublic = false }) => {
  const [leaderboard, setLeaderboard] = useState([]);
  
  useEffect(() => {
    const loadLeaderboard = async () => {
      try {
        const endpoint = isPublic ? `${API}/public/leaderboard` : `${API}/leaderboard`;
        const res = await axios.get(endpoint);
        setLeaderboard(res.data.leaderboard);
      } catch (e) {
        console.error(e);
      }
    };
    loadLeaderboard();
  }, [isPublic]);

  if (leaderboard.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="font-secondary text-muted-foreground">Aucune équipe dans le classement</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {leaderboard.map((team, idx) => {
        const stats = team.stats || { matches_won: 0, matches_lost: 0, win_rate: 0, total_matches: 0 };
        
        return (
          <div
            key={team.id}
            className="flex items-center justify-between p-4 bg-[#0a0a0a] border border-[#262626] hover:border-[#ff4500]/50 transition-colors"
            data-testid={`leaderboard-${idx}`}
          >
            <div className="flex items-center gap-4">
              <span className={`font-secondary text-2xl font-black ${idx === 0 ? 'text-[#ffd700]' : idx === 1 ? 'text-[#c0c0c0]' : idx === 2 ? 'text-[#cd7f32]' : 'text-muted-foreground'}`}>
                #{idx + 1}
              </span>
              <div>
                <p className="font-primary font-bold uppercase">{team.name}</p>
                <p className="font-secondary text-xs text-muted-foreground">
                  {stats.matches_won}W - {stats.matches_lost}L
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="font-secondary text-lg font-bold text-[#ff4500]">{stats.win_rate}%</p>
              <p className="font-secondary text-xs text-muted-foreground">{stats.total_matches} matchs</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};